import { type ClassValue, clsx } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge'

import { ENCUENTRO_TW_MERGE_THEME } from '@/lib/design/tailwind-merge'

// The Encuentro scale (text-en-*, rounded-en-*, shadow-en-*, min-h-en-control...)
// is registered so it merges like Tailwind's own; see lib/design/tailwind-merge.ts.
const twMerge = extendTailwindMerge({ extend: { theme: ENCUENTRO_TW_MERGE_THEME } })

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
